import { transactionProxy } from '../proxies/transactionProxy'
import { buildAxiosInstance } from '../utils/apiUtils'
import { customerProxy } from '../proxies/customerProxy'
import { convertFromCentValue } from '../utils/formattingUtils'
import { type GlobalTransactionHisType } from '../types/GlobalTransactionHisType'

export async function executeTransactionRetrieve (id: string): Promise<void> {
  transactionProxy.apiCall.loading = true
  transactionProxy.apiCall.error = null
  try {
    const response = await buildAxiosInstance().post('/api/transactions/retrieve', { transactionId: id })
    if (response.data.error) {
      transactionProxy.apiCall.error = response.data.error
    } else {
      const recentTxn: GlobalTransactionHisType = response.data?.data?.transaction ?? {}

      recentTxn.amountCents = convertFromCentValue(recentTxn.amountCents, recentTxn.amountCurrencyType)
      recentTxn.remainingAmountCents = convertFromCentValue(recentTxn.remainingAmountCents, recentTxn.remainingAmountCurrencyType)

      transactionProxy.transaction = recentTxn
    }
  } catch (e) {
    if (e instanceof Error) {
      transactionProxy.apiCall.error = e.message
    }
  } finally {
    transactionProxy.apiCall.loading = false
  }
}

export async function executeTransactionRetrieveForCustomerDetail (customerId: string | null | undefined): Promise<void> {
  if (!customerId) {
    return
  }
  customerProxy.apiCallCustomerTransactionSearch.loading = true
  customerProxy.apiCallCustomerTransactionSearch.error = null
  try {
    const response = await buildAxiosInstance().post('/api/transactions/search', { customerId: String(customerId) })
    if (response.data.error) {
      customerProxy.apiCallCustomerTransactionSearch.error = response.data.error
    } else {
      const recentT = response.data?.data?.transactions ?? []
      recentT.forEach((txn: GlobalTransactionHisType) => {
        txn.amountCents = convertFromCentValue(txn.amountCents, txn.amountCurrencyType)
        txn.remainingAmountCents = convertFromCentValue(txn.remainingAmountCents, txn.remainingAmountCurrencyType)
      })
      customerProxy.customerTransactions = recentT
    }
  } catch (e) {
    if (e instanceof Error) {
      customerProxy.apiCallCustomerTransactionSearch.error = e.message
    }
  } finally {
    customerProxy.apiCallCustomerTransactionSearch.loading = false
  }
}
